import React from 'react';
import PropTypes from 'prop-types';

import style from './quantity-column.module.less';
import messages from '../messages';
import { FormattedMessage } from 'react-intl';

const QuantityColumnId = 'QUANTITY_COLUMN';

const QuantityHeader = () => {
  return (
    <div className={style['quantity-cell']}>
      <FormattedMessage {...messages.orderItemsQuantityColumnLabel} />
    </div>
  );
};

const QuantityCell = ({ cell }) => {
  const { value } = cell;
  return <div className={style['quantity-cell']}>{value.quantity}</div>;
};

QuantityCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.shape({
      quantity: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export { QuantityCell, QuantityHeader, QuantityColumnId };
